import axios from "axios";

import _local from "utils/localStorageUtils";

// utils
import {
  DEVELOPMENT_LOCAL_API_URL,
  API_URL,
} from "utils/constants";

export const getBaseApiUrl = () => {
  /*
  const nodeENV = process.env.NODE_ENV,
    baseENV = process.env.BASE_ENV; */

  let apiURL = DEVELOPMENT_LOCAL_API_URL;

  if (process.env.BASE_ENV == "production") {
    /*
    if (window.location.origin.includes('app.schoolinked.com')) {
      apiURL = PRODUCTION_API_URL;
    }
    */
    apiURL = API_URL;
  } else if (process.env.BASE_ENV == "staging") {
    apiURL = API_URL;
  } else if (process.env.BASE_ENV == "development") {
    apiURL = API_URL;
  } else if (process.env.BASE_ENV == "local") {
    apiURL = API_URL;
  }

  // console.log("BASE_ENV:", process.env.BASE_ENV);
  // console.log("API_URL:", process.env.API_URL);
  // console.log("getBaseApiUrl:", { apiURL });

  return apiURL;
};

export const getLocalActiveSchool = () => {
  const currentUser = _local.getLocalUser();
  const currentSchool = _local.getLocalSchool();
  return (!!currentSchool && currentSchool) || currentUser?.activeSchool;
};

const parseConfig = config => ({
  method: config?.method?.toUpperCase(),
  pathname: config?.url,
});

function getTimeZone() {
  // Get the time zone from the Intl.DateTimeFormat object
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timeZone;
}

// Define a maximum number of retry attempts and a delay (in milliseconds) between retries
const MAX_RETRY_ATTEMPTS = 3;
const RETRY_DELAY_MS = 3000;

const AXIOS_CONFIG = {
  baseURL: getBaseApiUrl(), // Set your base URL here
  timeout: 30000, // Increase the timeout value to a higher value in milliseconds
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json", // 'application/x-www-form-urlencoded'
    "Accept-Language": localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr"
  },
  params: {},
  retry: MAX_RETRY_ATTEMPTS,
  retryDelay: RETRY_DELAY_MS,
};

const http = axios.create(AXIOS_CONFIG);

http.interceptors.request.use(
  config => {
    const currentUser = _local.getLocalUser();
    const currentSchool = getLocalActiveSchool();
    const timezone = getTimeZone();
    if (!!currentUser?.token) {
      config.headers["Authorization"] = `Token ${currentUser?.token}`;
    } else {
      delete config.headers.Authorization;
    }

    config.headers["timezone"] = !!timezone && timezone || "";

    config.headers["schoolConnection"] =
      currentSchool?.key ||
      `base-${
        process.env.BASE_ENV == "local" ? "development" : process.env.BASE_ENV
      }`;
    
      config.headers["Accept-Language"] = localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr"

    return config;
  },
  error => {
    const { method, pathname } = parseConfig(error.config);
    console.error("http error", `[${method}] Error (onRequest) ${pathname}`);
    // console.error("http request error:", error);
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  response => response,
  error => {
    const { code, message } = error;

    // retry while Network timeout or Network Error
    if (
      !(
        message.includes("timeout") ||
        message.includes("Network Error") ||
        code == "ECONNABORTED" ||
        code === "ERR_NETWORK"
      )
    ) {
      // console.error("http response error:", { error });
      return Promise.reject(error);
    } else {
      // if we have error on prev. request retry this request
      error.config.retry -= 1;
      // console.error("response error", { error });
      /* const delayRetryRequest = new Promise((resolve) => {
        setTimeout(() => {
          console.info(
            `Retrying request [${error?.config?.retry}/${MAX_RETRY_ATTEMPTS}]`,
            error?.config?.method?.toUpperCase(),
            error?.config?.url,
            error?.config
          );
          resolve();
        }, error?.config?.retryDelay || RETRY_DELAY_MS);
      });
      // Create a new Axios instance for each retry attempt
      const retryAxios = axios.create(AXIOS_CONFIG);
      return delayRetryRequest.then(() => retryAxios(error?.config)); */
           }
  },
);

export function setAuthorizationHeader(token, connectoin) {
  const currentUser = _local.getLocalUser();
  if (!!token || currentUser?.token) {
    const initToken = !!token ? token : currentUser?.token;
    http.defaults.headers.common.Authorization = `Token ${initToken}`;
    !!connectoin && (http.defaults.headers.common.schoolConnection = connectoin);
    if (!http?.defaults?.headers?.common?.timezone) {
      const timezone = getTimeZone();
      http.defaults.headers.common.timezone = !!timezone && timezone || ""
    }
  } else {
    delete http.defaults.headers.common.Authorization;
  }
  return currentUser?.token;
}

export const postData = ({ endpoint, body = {} }, config) =>
  !!endpoint && http.post(endpoint, body, config).then(res => res?.data || res);
export const postFormData = ({ endpoint, file }) =>
  !!endpoint && http.postForm(endpoint, file).then(res => res?.data || res);
export const getData = ({ endpoint, body = {} }, config) =>
  !!endpoint && http.get(endpoint, body, config).then(res => res?.data || res);
export const patchData = ({ endpoint, body = {} }, config) =>
  !!endpoint && http.patch(endpoint, body, config).then(res => res?.data || res);

/* Simple FETCH */
const generateFetchOptions = config => {
  const currentUser = _local.getLocalUser();
  const currentSchool = getLocalActiveSchool();
  const timezone = getTimeZone();
  let headers = {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json",
    timezone: !!timezone && timezone || ""
  };
  // copy headers from config and put on right plase
  if (!!config?.headers) {
    headers = {
      ...headers,
      ...config?.headers,
    };
    delete config.headers;
  }
  if (!!currentUser?.token) {
    headers["Authorization"] = `Token ${currentUser?.token}`;
  } else {
    delete headers.Authorization;
  }

  headers["schoolConnection"] =
    currentSchool?.key ||
    `base-${
      process.env.BASE_ENV == "local" ? "development" : process.env.BASE_ENV
    }`;
  
  headers["Accept-Language"] = localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr"

  return {
    headers: headers,
    ...config,
  };
};
const httpFetch = {
  async fetchWithRetry(url, options, retries = 0) {
    try {
      const response = await fetch(url, options);

      if (!response.ok && retries < MAX_RETRY_ATTEMPTS) {
        // Retry if the response is not OK and the number of retries is not exceeded
        await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS));
        return this.fetchWithRetry(url, options, retries + 1);
      }

      return response;
    } catch (error) {
      // Retry if there's a network error or a timeout and the number of retries is not exceeded
      if (retries < MAX_RETRY_ATTEMPTS) {
        await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS));
        return this.fetchWithRetry(url, options, retries + 1);
      }

      throw error;
    }
  },
};

export async function postDataFetch({ endpoint, body }, config) {
  const options = generateFetchOptions(config) || {};
  const requestOptions = {
    ...options,
    method: "POST",
    body: JSON.stringify(body),
  };

  const response = await httpFetch.fetchWithRetry(
    getBaseApiUrl() + endpoint,
    requestOptions,
  );
  return response.json();
}

export async function getDataFetch({ endpoint, body }, config) {
  const options = generateFetchOptions(config) || {};
  const requestOptions = {
    ...options,
    method: "GET",
    body: JSON.stringify(body),
  };

  const response = await httpFetch.fetchWithRetry(
    getBaseApiUrl() + endpoint,
    requestOptions,
  );
  return response.json();
}

// as default is axios
export default http;
